import { render, staticRenderFns } from "./InstrumentList.vue?vue&type=template&id=23df4cd9"
import script from "./InstrumentList.vue?vue&type=script&lang=ts"
export * from "./InstrumentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports